enum DiscountRuleRoutes {
  List = '/content-settings/discount-rules',
  Add = '/content-settings/discount-rules/add',
  Edit = '/content-settings/discount-rules/:id',
}

export default DiscountRuleRoutes
